import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const ProductFamilyImageSchema_ = z.object({
  id: z.string(),
  url: z.string(),
  alt_text: z.string(),
  position: z.number(),
});

const ProductInFamilySchema_ = z.object({
  id: productIdFormat.schema,
  title: z.string(),
  sku: z.string().nullable(),
  upc: z.string().nullable(),
  price: z.number().nullable(),
  vendor: z.string().nullable(),
  created_at: z.date(),
  updated_at: z.date(),
});

const ProductFamilyDetailsSchema_ = z.object({
  id: productFamilyIdFormat.schema,
  title: z.string(),
  description: z.string(),
  vendor: z.string().nullable(),
  created_at: z.date(),
  updated_at: z.date(),
  images: z.array(ProductFamilyImageSchema_),
  products: z.array(ProductInFamilySchema_),
});

export const ProductFamilyDetailsSchema: z.ZodType<ProductFamilyDetails> =
  ProductFamilyDetailsSchema_;
export interface ProductFamilyDetails
  extends z.infer<typeof ProductFamilyDetailsSchema_> {}

export const getProductFamilyDetails = {
  name: "getProductFamilyDetails" as const,
  input: z.object({ productFamilyId: productFamilyIdFormat.schema }),
  output: z.object({ productFamily: ProductFamilyDetailsSchema.nullable() }),
};
